import React, { FC } from 'react';

interface Props {
  className?: string;
  size?: number;
  color?: string;
}

export const ForwardIcon: FC<Props> = ({ className, size = 20, color = 'currentColor' }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7.97949 10L4.16699 6.16667L5.33366 5L10.3337 10L5.33366 15L4.16699 13.8333L7.97949 10ZM13.4795 10L9.66699 6.16667L10.8337 5L15.8337 10L10.8337 15L9.66699 13.8333L13.4795 10Z" />
    </svg>
  );
};
